import type { AdminWalletActivityWindow, AdminWalletStatisticsOverview } from "@shopexperts/legacy-api";

/**
 * One shared money-color system for the whole statistics tab:
 * emerald = payable now, amber = still on hold, indigo = liability added,
 * slate = liability cleared. Pairs validated for CVD separation on white.
 */
export const LIABILITY_COLORS = {
  available: {
    bar: "bg-emerald-500",
    text: "text-emerald-700",
  },
  hold: {
    bar: "bg-amber-600",
    text: "text-amber-700",
  },
  added: {
    bar: "bg-indigo-600",
    text: "text-indigo-700",
  },
  cleared: {
    bar: "bg-slate-500",
    text: "text-slate-600",
  },
} as const;

export type ActivityWindowKey = keyof AdminWalletStatisticsOverview["activity"];

export const ACTIVITY_WINDOW_OPTIONS: readonly { label: string; value: ActivityWindowKey }[] = [
  { label: "This month", value: "this_month" },
  { label: "Last month", value: "last_month" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "All time", value: "all_time" },
];

export interface ActivityFlowRow {
  key: keyof Pick<
    AdminWalletActivityWindow,
    "earned_cents" | "admin_adjustments_cents" | "paid_out_cents" | "refunded_cents"
  >;
  label: string;
  hint: string;
  polarity: "added" | "cleared";
}

export const ACTIVITY_FLOWS: readonly ActivityFlowRow[] = [
  {
    key: "earned_cents",
    label: "Expert earnings",
    hint: "Quote settlements and external payments credited to expert wallets.",
    polarity: "added",
  },
  {
    key: "admin_adjustments_cents",
    label: "Admin adjustments",
    hint: "Credits and direct holds added by the team.",
    polarity: "added",
  },
  {
    key: "paid_out_cents",
    label: "Paid out",
    hint: "Payouts and corrections that cleared money owed to experts.",
    polarity: "cleared",
  },
  {
    key: "refunded_cents",
    label: "Refunded",
    hint: "Refunds to clients taken back out of expert wallets.",
    polarity: "cleared",
  },
];
